import React from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/site";

export const Testimonials = () => {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 md:py-32 bg-brand-surface border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-brand-gold/90">
          <span className="inline-block h-px w-10 bg-brand-gold" />
          What our clients say
        </div>
        <h2 className="mt-4 font-serif text-4xl md:text-6xl text-white leading-tight max-w-4xl text-balance">
          Word-of-mouth keeps us{" "}
          <span className="text-brand-gold italic">on the tools</span>.
        </h2>

        <div className="mt-14 grid lg:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-brand-card border border-white/5 p-8 md:p-10 rounded-sm flex flex-col"
            >
              <Quote className="h-7 w-7 text-brand-gold" />
              <blockquote className="mt-6 font-serif text-xl md:text-2xl text-white/95 leading-snug">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-auto pt-8 text-sm uppercase tracking-[0.22em] text-white/60">
                <span className="text-white">{t.author}</span> · {t.location}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
